import React from 'react';

const moment = require('moment');
// const stylesPdf = StyleSheet.create({
//   body: {
//     paddingTop: 20,
//     paddingBottom: 40,
//     paddingHorizontal: 35,
//   },
//   title: {
//     fontSize: 20,
//     textAlign: 'center',
//     fontFamily: 'Oswald'
//   },
//   author: {
//     fontSize: 12,
//     textAlign: 'center',
//     marginBottom: 5,
//   },
//   subtitle: {
//     fontSize: 18,
//     margin: 12,
//     fontFamily: 'Oswald'
//   },
//   text: {
//     margin: 12,
//     fontSize: 14,
//     textAlign: 'justify',
//     fontFamily: 'Times-Roman'
//   },
//   image: {
//     marginVertical: 10,
//     marginHorizontal: 200,
//   },
//   header: {
//     fontSize: 10,
//     marginBottom: 5,
//     textAlign: 'center',
//     color: 'grey',
//   },
//   label_title: {
//     fontSize: 10,
//     marginBottom: 5,
//     color: 'grey',
//   },
//   label_strong: {
//     fontSize: 10,
//     marginBottom: 5,
//     color: '#156185',
//   },
//   label: {
//     fontSize: 10,
//     marginBottom: 5,
//     color: 'black',
//   },
//   pageNumber: {
//     position: 'absolute',
//     fontSize: 12,
//     bottom: 30,
//     left: 0,
//     right: 0,
//     textAlign: 'center',
//     color: 'grey',
//   },
// });
const FichaPreview = (ficha: any) => {
  console.log(ficha);
  return ({});
  // <Document title={'Ficha Covid'}>
  //   <Page size="A4" style={stylesPdf.body}>
  //     <Text2 style={stylesPdf.header} fixed>
  //       ~ Ficha {ficha.codigo} ~
  //     </Text2>
  //     <Text2 style={stylesPdf.title}>{ficha.estadoId === 1 ? '“PUEDE INGRESAR”' : '“NO PUEDE INGRESAR”'}</Text2>
  //     <Text2 style={stylesPdf.author}>{ficha.nombreApellido}</Text2>
  //     {
  //       ficha.estadoId === 1 || ficha.estadoId === 5 ? <Image style={stylesPdf.image} src="/content/smile-regular.png" /> : <Image style={stylesPdf.image} src="/content/frown-regular.png" />
  //     }
  //     <Text2 style={stylesPdf.label}>Dni:</Text2>
  //     <Text2 style={stylesPdf.label_title}>{ficha.dni}</Text2>
  //     <Text2 style={stylesPdf.label}>Dirección:</Text2>
  //     <Text2 style={stylesPdf.label_title}>{ficha.direccion}</Text2>
  //     <Text2 style={stylesPdf.label}>Fecha Registro:</Text2>
  //     <Text2 style={stylesPdf.label_title}>{moment(ficha.fechaReg).format('DD/MM/yyyy h:mm a')}</Text2>
  //     <Text2 style={stylesPdf.label}>Estado:</Text2>
  //     <Text2 style={stylesPdf.label_title}>{ficha.estado}</Text2>
  //     <Text2 style={stylesPdf.author}>En los últimos 10 días calendario ha tenido algunos síntomas siguientes:</Text2>
  //     <Text2 style={stylesPdf.label}>¿Haz tenido alguno de estos síntomas en los últimos 14 dias?</Text2>
  //     <Text2 style={stylesPdf.label_title}>Sensación de alza térmica, fiebre o malestar: <Text2 style={stylesPdf.label_strong}>{ficha.fiebre ? 'Si' : 'No'}, {ficha.nombreTemperatura}</Text2></Text2>
  //     <Text2 style={stylesPdf.label_title}>Dolor de garganta, tos, estornudos o dificultad para respirar: <Text2 style={stylesPdf.label_strong}>{ficha.tosSeca ? 'Si' : 'No'},</Text2></Text2>
  //     <Text2 style={stylesPdf.label_title}>Dolor de cabeza, diarrea o congestión nasal: <Text2 style={stylesPdf.label_strong}>{ficha.dolorCabezaDiarrea ? 'Si' : 'No'},</Text2></Text2>
  //     <Text2 style={stylesPdf.label_title}>Pérdida del gusto y/o del olfato.: <Text2 style={stylesPdf.label_strong}>{ficha.gustoPerdida ? 'Si' : 'No'}, {ficha.nombreNivelGusto}</Text2></Text2>
  //
  //
  //     {/* <Text2 style={stylesPdf.label_title}>Pérdida del gusto: <Text2 style={stylesPdf.label_strong}>{ficha.gustoPerdida ? 'Si' : 'No'}, {ficha.nombreNivelGusto}</Text2></Text2>
  //     <Text2 style={stylesPdf.label_title}>Pérdida del olfato: <Text2 style={stylesPdf.label_strong}>{ficha.olfatoPerdida ? 'Si' : 'No'},</Text2></Text2>
  //      */}
  //     {/* <Text2 style={stylesPdf.label_title}>Expectoración de flema: <Text2 style={stylesPdf.label_strong}>{ficha.flema ? 'Si' : 'No'}, {ficha.nombreTipoExpectoracion}</Text2></Text2> */}
  //     <Text2 style={stylesPdf.label}>¿Contacto con un caso confirmado de COVID-19?</Text2>
  //     <Text2 style={stylesPdf.label_title}><Text2 style={stylesPdf.label_strong}>{ficha.cercaniaCovid ? 'Si' : 'No'}</Text2></Text2>
  //     {/* <Text2 style={stylesPdf.label}>¿Esta tomando alguna medicación?</Text2>
  //     <Text2 style={stylesPdf.label_title}><Text2 style={stylesPdf.label_strong}>{ficha.medicacion ? 'Si' : 'No'}, {ficha.medicacionDescripcion}</Text2></Text2> */}
  //     <Text2 style={stylesPdf.label}>¿Pertenece a algún Grupo de Riesgo para COVID-19?</Text2>
  //     <Text2 style={stylesPdf.label_title}><Text2 style={stylesPdf.label_strong}>{ficha.perteneceGrupoRiesgoCovid ? 'Si' : 'No'}</Text2></Text2>
  //
  //     <Text2 style={stylesPdf.label}>Está tomando alguna medicación (detallar cuál o cuáles) </Text2>
  //     <Text2 style={stylesPdf.label_title}><Text2 style={stylesPdf.label_strong}>{ficha.medicacion ? 'Si' : 'No'}, {ficha.medicacionDescripcion}</Text2></Text2>
  //   </Page>
  // </Document>
  //);
//}
}
  export default FichaPreview;
